import Vue from "vue";
import Vuex from "vuex";
import { functions } from "@/utils/functions";

Vue.use(Vuex);

export const general_services = {
  namespaced: true,
  state: () => ({
    generalServices: null,
    generalService: null,
  }),
  mutations: {
    SET_GENERAL_SERVICES(state, data) {
      state.generalServices = data;
    },
    SET_GENERAL_SERVICE(state, data) {
      state.generalService = data;
    },
  },
  actions: {
    fetchGeneralServices({ commit }, queryParams = {}) {
      this.$store.dispatch("loading/triggerTableLoader");
      const url = `encoder/general-services`;
      const query = functions.query(url, queryParams);

      return this.$axios
        .get(query)
        .then((response) => {
          commit("SET_GENERAL_SERVICES", response.data);
        })
        .catch((error) => {
          console.error("Error fetching general services: ", error);
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerTableLoader");
        });
    },
    fetchGeneralService({ commit }, id) {
      const url = `encoder/general-services/${id}`;

      return this.$axios
        .get(url)
        .then((response) => {
          commit("SET_GENERAL_SERVICE", response.data.data);
        })
        .catch((error) => {
          console.error("Error general services: ", error);
        });
    },
    toggleGeneralServiceStatus({ dispatch }, { serviceID, citizenID, status }) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `hospital-services/${serviceID}/toggle-status`;

      return this.$axios
        .patch(url, status)
        .then((response) => {
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
          dispatch("fetchGeneralService", citizenID);
        })
        .catch((error) => {
          console.error("Error patching general service status: ", error);
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        });
    },
    resetGeneralServices({ commit }) {
      commit("SET_GENERAL_SERVICES", null);
    },
    resetGeneralService({ commit }) {
      commit("SET_GENERAL_SERVICE", null);
    },
  },
};
